import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';

import DeleteIcon from '../Icons/Delete';

const styles = createStyles({
  fields: {
    maxWidth: 500
  }
});

type Props = {
  classes: any,
  onClick: any
};

type StateProps = {
  open: boolean
};

class ConfirmDeleteIcon extends Component<Props, StateProps> {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClick = () => {
    this.props.onClick();
    this.setState({ open: false });
  };

  render() {
    return (
      <span style={{ cursor: 'pointer' }}>
        <DeleteIcon onClick={this.handleOpen} />
        <Dialog open={this.state.open} className={this.props.classes.fields}>
          <DialogContent>
            <DialogContentText>Are you sure?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClose}>Cancel</Button>
            <Button color="primary" onClick={this.handleClick}>Ok</Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

export default withStyles(styles)(ConfirmDeleteIcon);



// WEBPACK FOOTER //
// ./src/views/Common/Buttons/ConfirmDeleteIcon.tsx